import Link from "@mui/material/Link";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import packageJson from '../../../package.json';
import version from '../../version.json';

// Material Dashboard 2 PRO React base styles
import {CONSTANTS} from "../../app/common/constants";
import CoffeeIcon from '@mui/icons-material/Coffee';
function Footer({ company, links }) {

// Setting default values for the props of Footer
  const defaultProps = {
    company: { href: "https://playspacebrain.com/", name: "Play Space Brain" },
    links: [
      { href: "#cx/terms-of-service", name: "Terms" },
      { href: "https://playspacebrain.com/", name: "playspacebrain.com" },
    ],
  };

  const renderLinks = () =>
    defaultProps.links.map((link) => (
      <MDBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <MDTypography variant="button" fontWeight="regular" color="text">
            {link.name}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox
      width="100%"
      display="flex"
      sx={{
        position: "absolute",
        bottom: "0",
        width: "95%",
        padding: "10px",
      }}
      flexDirection={{xs: "column", lg: "row"}}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
    >

      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={'12px'}
        px={1.5}
      >
       &copy; {new Date().getFullYear()},
        &nbsp;
        <CoffeeIcon />&nbsp;Play Space Brain {CONSTANTS.DISPLAY_ENVIRONMENT}{packageJson.version}.{version.buildNumber}
      </MDBox>
      <MDBox
        component="ul"
        sx={({breakpoints}) => ({
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          listStyle: "none",
          mt: 3,
          mb: 0,
          p: 0,

          [breakpoints.up("lg")]: {
            mt: 0,
          },
        })}
      >
        {renderLinks()}
      </MDBox>

    </MDBox>
  );
}

export default Footer;
